import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ShipmentsService} from "../services/shipments.service";
import {ApiResponse, AuthService, BaseService} from '@hassel-it/angular-common';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-shipment-address-picker',
    templateUrl: './shipment-address-picker.component.html',
    styleUrls: ['./shipment-address-picker.component.scss']
})
export class ShipmentAddressPickerComponent implements OnChanges {
    @Input() shipmentAddresses: any[] = [];
    @Output() picked = new EventEmitter<any>();

    searchTerm = '';
    selectedAddress: any = null;
    modal: NgbModalRef;

    addressTypes = [
        {value: 'receiver', label: 'Receiver'},
        {value: 'sender', label: 'Sender'},
        {value: 'droppoint', label: 'Droppoint'}
    ];

    constructor(public shipmentsService: ShipmentsService) {
    }


    ngOnInit(): void {
        this.load();
    }


    load() {
        this.shipmentsService.getShipmentAdresses(1, {})
            .subscribe((response: ApiResponse) => {
                this.shipmentAddresses = response.results;
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.shipmentAddresses) {
            if (!this.shipmentAddresses) {
                this.shipmentAddresses = [];
            }

            if (this.shipmentAddresses.length > 0) {
                if (!this.selectedAddress || !this.shipmentAddresses.includes(this.selectedAddress)) {
                    this.selectedAddress = this.shipmentAddresses[0];
                }
            } else {
                this.selectedAddress = null;
            }
        }
    }

    get filteredAddresses(): any[] {
        const term = this.searchTerm.trim().toLowerCase();
        if (!term) {
            return this.shipmentAddresses;
        }

        return this.shipmentAddresses.filter((address) => this.addressMatches(address, term));
    }

    selectAddress(address: any) {
        this.selectedAddress = address;
    }

    pick() {
        this.picked.emit(this.selectedAddress);
    }

    addAddress() {
        const address = this.buildEmptyAddress();
        this.shipmentAddresses.push(address);
        this.selectedAddress = address;
    }

    trackByAddress(index: number, address: any) {
        return address?.id || index;
    }

    onFieldChange() {
    }

    private addressMatches(address: any, term: string): boolean {
        const fields = [
            address?.address_type,
            address?.name_1_receiver,
            address?.name_2_receiver,
            address?.adress_1_receiver,
            address?.adress_2_receiver,
            address?.postal_code_receiver,
            address?.city_receiver,
            address?.country_code_receiver,
            address?.phone_receiver,
            address?.email_receiver,
            address?.droppoint_reference
        ];

        return fields.some((field) => (field ?? '').toString().toLowerCase().includes(term));
    }

    private buildEmptyAddress() {
        return {
            address_type: 'receiver',
            name_1_receiver: '',
            name_2_receiver: '',
            adress_1_receiver: '',
            adress_2_receiver: '',
            postal_code_receiver: '',
            city_receiver: '',
            country_code_receiver: '',
            phone_receiver: '',
            email_receiver: '',
            droppoint_reference: ''
        };
    }

    save() {

        if (this.selectedAddress.id) {
            this.shipmentsService.updateShipmentAddress(this.selectedAddress).subscribe(
                (response: ApiResponse) => {
                    this.selectedAddress = null;
                    this.load();
                }
            )
        } else {
            this.shipmentsService.addShipmentAddress(this.selectedAddress).subscribe((response: ApiResponse) => {
                this.selectedAddress = null;
                this.load();
            })
        }
    }

    protected deleteAddress() {
        if (this.selectedAddress.id) {
            if (confirm('Are you sure you want to delete this address?')) {
                this.shipmentsService.deleteShipmentAddress(this.selectedAddress).subscribe(() => {
                    this.selectedAddress = null;
                    this.load();
                })
            }
        }
    }
}
